<app-task-completed-note
  #taskCompletedModal
  [currentTask]="currentTask"
></app-task-completed-note>

<div>
  <table class="table table-striped spacing-table">
    <thead>
      <tr class="p-1">
        @for (column of columns; track column) {
          <th>
            @if (column !== this.app.fieldId.post.taskCompleted) {
              <span>
                {{ app.field.getLabel(column) }}
              </span>
            }
          </th>
        }
      </tr>
    </thead>
    @for (task of app.post.tasks; track task) {
      <tbody>
        <tr>
          @for (column of shortColumns; track column) {
            <td
              class="p-1"
              (click)="app.tasks.openTaskPanel(task)"
              >
              <div>
                @switch (app.table.getColumnTypeDisplay(column)) {
                  @case ('optionText') {
                    <div
                      (click)="$event.stopPropagation()"
                      >
                      @if (!task.taskCompleted) {
                        <button
                          class="btn btn-sm"
                [disabled]="
                  !app.taskCompleted.showCompleteTaskIcon(task) ||
                  task.cannotCloseTask
                "
                          (click)="currentTask = task; taskCompletedModal.openModal()"
                          [ngbTooltip]="app.text.post.markTaskCompleted"
                          >
                          <i class="far fa-check-circle"></i>
                        </button>
                      }
                      @if (task.taskCompleted) {
                        <button
                          class="btn btn-sm"
                          [disabled]="!app.taskCompleted.showReopenTaskIcon(task)"
                (click)="
                  app.taskCompleted.changeTaskCompletion(app.customer, task)
                "
                          [ngbTooltip]="app.text.post.markTaskIncomplete"
                          >
                          <i class="fas fa-check-circle"></i>
                        </button>
                      }
                    </div>
                  }
                  @case ('dueDate') {
                    <div class="date-min-width">
                      @if (task[column] > 0) {
                        <span
                [ngStyle]="
                  app.tasks.getTaskDueDateColor(
                    task[column],
                    task.taskCompleted
                  )
                "
                          >
                          {{ task[column] | date : "yyyy-MM-dd" : "UTC" }}
                        </span>
                      }
                    </div>
                  }
                  @case ('getUser') {
                    <div>
                      {{app.users.getOptionName(task[column])}}
                    </div>
                  }
                  @case ('time') {
                    <div>
                      @if (task[column] > 0) {
                        <span>
                          {{ task[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                        </span>
                      }
                    </div>
                  }
                  @default {
                    <div class="column-width">
                      {{ task[column] }}
                    </div>
                  }
                }
              </div>
            </td>
          }
        </tr>
      </tbody>
    }
  </table>
</div>
